module.exports = __webpack_public_path__ + "img/User_cicrle_duotone_line.4a33985a.svg";